import { render } from "./UseCouponModal.vue?vue&type=template&id=09267528"
import script from "./UseCouponModal.vue?vue&type=script&lang=js"
export * from "./UseCouponModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__